var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "clear_svg__svg-icon",
    style: {
      width: 24,
      height: 24,
      verticalAlign: "middle"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    overflow: "hidden"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.667 273.707l-60.374-60.374L512 451.627 273.707 213.333l-60.374 60.374L451.627 512 213.333 750.293l60.374 60.374L512 572.373l238.293 238.294 60.374-60.374L572.373 512z"
  })));
}
export default SvgClear;